export default __webpack_public_path__ + "static/media/Levitate D2.7 Policy Recommendations Brochure.294115ec.pdf";